export default __webpack_public_path__ + "static/media/emratG.b58977ea.png";